<template>
  <div class="tijian">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="套餐类型:">
        <el-radio-group
          v-model="form.tj_package_type"
          @change="change"
        >
          <el-radio label="1">定制套餐</el-radio>
          <!-- <el-radio label="2">固定套餐</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="费用区间:">
        <el-row type="flex">
          <el-col :span="11">
            <el-input-number
              :disabled="form.tj_package_type != 1"
              v-model="form.tj_fee_start"
              controls-position="right"
              @change="change"
              :min="10000"
              :max="10000000"
            ></el-input-number>
            <!-- <el-input
              
              v-model="form.tj_fee_start"
              type="number"
              @change="change"
            ></el-input> -->
          </el-col>
          <el-col
            class="line"
            :span="2"
          >到</el-col>
          <el-col :span="11">
            <el-input-number
              :disabled="form.tj_package_type != 1"
              v-model="form.tj_fee_end"
              controls-position="right"
              @change="change"
              :min="10000"
              :max="10000000"
            ></el-input-number>
            <!-- <el-input
              :disabled="form.tj_package_type != 1"
              v-model="form.tj_fee_end"
              type="number"
              @change="change"
            ></el-input> -->
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="套餐备注:">
        <el-input
          v-model="form.tj_package_remark"
          @change="change"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="套餐名称:">
        <el-select
          filterable
          remote
          v-model="form.package"
          :disabled="form.tj_package_type != 2 || !customerInfo.user_sex"
          placeholder=""
          value-key="packageId"
          @change="comboChange"
          :remote-method="remoteMethod"
          class="package-select"
        >
          <el-option
            v-for="item in comboList"
            :key="item.packageId"
            :label="item.packageName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import mixins from "./mixins";
import menZhenService from "@/apis/menZhen/index";
import { mapGetters } from "vuex";

export default {
  name: "tijianPackage",
  mixins: [mixins],
  data() {
    return {
      answer: "",
      comboList: [],
      form: {
        tj_package_type: "1",
      },
    };
  },
  computed: {
    ...mapGetters(["customerInfo"]),
  },
  watch: {
    customerInfo: {
      handler(newVal) {
        if (newVal.user_sex) this.getWorkAddInit();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // this.getWorkAddInit()
  },
  methods: {
    getWorkAddInit(value = "") {
      const { customerInfo } = this;
      const params = {
        sex: customerInfo.user_sex,
        packageName: value,
      };
      menZhenService.getWorkAddInit(params).then((res) => {
        console.log(res);
        this.comboList = res;
      });
    },
    remoteMethod(query) {
      this.getWorkAddInit(query);
    },
    comboChange(item) {
      console.log(item);
      this.form = {
        ...this.form,
        tj_package_id: item.packageId,
        tj_package_name: item.packageName,
        tj_package_price: item.packagePrice,
      };
      this.change();
    },
    change() {
      this.answerChange(this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.tijian {
  .line {
    text-align: center;
  }
}
</style>
<style lang="scss">
.tijian {
  .el-input-number--small {
    width: 100%;
  }
}
</style>



